import styled from 'styled-components/macro';

import media from '../../styles/media';
import { fontSize } from '../../styles/mixins';

export const Chat = styled.button`
  position: absolute;
  color: ${({ theme }) => theme.chatTextColor};
  padding: 10px;
  background-color: ${({ theme }) => theme.chatBgColor};
  border-radius: 5px 5px 3px 3px;
  cursor: pointer;
  border: 0;
  right: 20px;
  top: 10px;
  ${fontSize(12)};
  font-weight: bold;

  .dots {
    margin-left: 5px;
    letter-spacing: 3px;
  }

  &::after {
    content: '';
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 8px 0 0 8px;
    border-color: transparent transparent transparent
      ${({ theme }) => theme.chatBgColor};
    position: absolute;
    right: -5px;
    bottom: 0px;
  }

  ${media.desktop`
    top: 25px;
    right: 150px;
  `};
`;
